import { gql } from '@apollo/client'
import { ArticleGridBlockFragment, FeaturedArticleBlockFragment } from 'app/features/blog/blocks'
import { FeaturedOfferBlockFragment, OfferCollectionBlockFragment } from 'app/features/offer/blocks'
import {
  BaseBlock,
  ButtonBlockFragment,
  ColumnLayoutBlockFragment,
  FaqsBlockFragment,
  FeaturedContentCarouselBlockFragment,
  HeadingBlockFragment,
  HtmlBlockFragment,
  ImageBlockFragment,
  JumpToLinksBlockFragment,
  RichTextBlockFragment,
  ShareLinkBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchFreshersPage($draft: Boolean!) {
    FreshersPage(draft: $draft) {
      title
      excerpt
      primaryCategory {
        name
        slug
      }
      featuredImage {
        url
        alt
      }
      content {
        ${ArticleGridBlockFragment.partialFragment}
        ${ButtonBlockFragment.partialFragment}
        ${ColumnLayoutBlockFragment.partialFragment}
        ${FaqsBlockFragment.partialFragment}
        ${FeaturedArticleBlockFragment.partialFragment}
        ${FeaturedContentCarouselBlockFragment.partialFragment}
        ${FeaturedOfferBlockFragment.partialFragment}
        ${HeadingBlockFragment.partialFragment}
        ${HtmlBlockFragment.partialFragment}
        ${ImageBlockFragment.partialFragment}
        ${JumpToLinksBlockFragment.partialFragment}
        ${OfferCollectionBlockFragment.partialFragment}
        ${RichTextBlockFragment.partialFragment}
        ${ShareLinkBlockFragment.partialFragment}
        ${SpacerBlockFragment.partialFragment}
      }
      slug
      updatedAt
    }
  }
`

export interface FreshersPageQueryInput {
  draft: boolean
}

export interface FreshersPageQueryOutput {
  FreshersPage: {
    title: string
    excerpt?: string
    primaryCategory: {
      name: string
      slug: string
    }
    featuredImage: {
      url: string
      alt: string
    }
    content: BaseBlock[]
    slug: string
    updatedAt: string
  }
}

export const useFreshersPageQuery = (input: FreshersPageQueryInput) =>
  usePersistedCacheQuery<FreshersPageQueryOutput, FreshersPageQueryInput>(query, { variables: input })

export const freshersPageQuery = { query }
